<template>
	<b-card no-body tag="article">
		<b-card-header class="d-flex align-items-center">
			<h3 class="h6 mb-0 mr-auto">
				<b>{{ title }}</b>
			</h3>

			<b-button-group class="ml-3">
				<b-button class="border" disabled size="sm" variant="light">
					{{ $t(elementType) }}
				</b-button>
				<duplicate-modal
					:api-url="`${apiUrl}/duplicate`"
					:project-id="projectId"
					only-locations
				>
					<template #activator="{duplicating, show}">
						<b-button
							:disabled="duplicating"
							:title="$t('Duplicate')"
							size="sm"
							style="border-radius: 0"
							@click="show()"
						>
							<fa :spin="duplicating" fixed-width icon="copy" />
							<span class="sr-only">{{ $t('Duplicate') }}</span>
						</b-button>
					</template>
				</duplicate-modal>
				<b-button
					:to="{ name: 'projects.elements.show', params: { projectId: projectId, id: element.id } }"
					size="sm"
					target="_blank"

					variant="primary"
				>
					<fa fixed-width icon="edit" />
				</b-button>
				<b-button
					size="sm"
					variant="danger"
					@click="handleDelete"
				>
					<fa fixed-width icon="trash" />
				</b-button>
			</b-button-group>
		</b-card-header>

		<b-card-body>
			<b-form @submit.prevent="handleSave">
				<b-row class="px-3">
					<b-form-group :label="$t('Count')">
						<b-form-spinbutton
							:value="propertiesCount"
							min="0"
							@change="handleCountChange"
						/>
					</b-form-group>
				</b-row>

				<b-row
					v-if="propertiesCount"
					class="px-3"
				>
					<b-col
						v-for="(property, propertyNumber) in form.properties"
						:key="propertyNumber"
						class="pl-0 pr-1 pb-1 list-complete-item"
						cols="12"
						@input="handleDirtyProperties"
					>
						<b-row class="border rounded bg-light mt-3 pt-2">
							<div class="close-button">
								<b-button variant="danger" style="height: 20px; width: 20px; border-radius:100%; line-height: 20px"
										  class="p-0 m-0"
										  @click="handlePropertyDelete(propertyNumber)"
								>
									<fa icon="times" />
								</b-button>
							</div>
							<div class="col-xl-6 col-lg-12 ">
								<b-row>
									<!-- Property Fields-->
									<b-form-group
										v-for="(field, index) in fieldsLookup"
										:key="index"
										:invalid-feedback="form.errors.get(`properties.${propertyNumber}.fields.${index}.value`)"
										:label="field.label"
										:label-for="`${field.name}_${value.id}_${propertyNumber}`"
										:state="form.errors.has(`properties.${propertyNumber}.fields.${index}.value`) ? true : null"
										class="col-6"
									>
										<b-input-group v-if="form.properties[propertyNumber].fields">
											<b-input-group-prepend>
												<b-button
													v-model="form.properties[propertyNumber].fields[index].subtract"
													:variant="form.properties[propertyNumber].fields[index].subtract ? 'danger' : 'secondary'"
													name="check-button"
													@click="form.properties[propertyNumber].fields[index].subtract = !form.properties[propertyNumber].fields[index].subtract"
												>
									<span
										v-text="form.properties[propertyNumber].fields[index].subtract ? '-' : '+'"
									/>
												</b-button>
											</b-input-group-prepend>
											<b-form-input
												v-model="form.properties[propertyNumber].fields[index].value"
												step="0.001"
												type="number"
											/>

											<b-input-group-append v-if="field.append" class="" is-text>
												<span v-html="field.append" />
											</b-input-group-append>
										</b-input-group>
									</b-form-group>
								</b-row>
							</div>
							<div class="col-xl-6 col-lg-12">
								<b-row>
									<!-- Subtraction Mode-->
									<div class="col-6">
										<subtraction-mode-select
											:default-element-mode="element.subtraction_mode"
											:override="true"
											:value="form.properties[propertyNumber].subtraction_mode || 0"
											@input="$set(form.properties[propertyNumber], 'subtraction_mode',$event)"
										/>
									</div>
									<!-- Covering Area-->
									<div v-if="form.properties[propertyNumber].covering_area" class="col-6">
										<label class="d-block w-100">{{ $t('Covered Area') }}</label>
										<b-input-group>
											<b-form-input
												:state="dirtyProperties.find(value => value === propertyNumber) !== undefined ? false: null"
												:value="form.properties[propertyNumber].covering_area.toFixed(2)"
												disabled
											/>
											<b-form-invalid-feedback>
												{{ $t('needs recalculation') }}
											</b-form-invalid-feedback>
											<b-input-group-append
												v-show="dirtyProperties.find(value => value === propertyNumber) === undefined"
											>
												<b-button disabled variant="dark">
													m²
												</b-button>
											</b-input-group-append>
										</b-input-group>
									</div>
								</b-row>
							</div>
						</b-row>
					</b-col>
				</b-row>
			</b-form>
		</b-card-body>
		<b-card-footer v-if="isDirty">
			<b-button :disabled="saving" type="submit" variant="primary" @click="handleSave">
				{{ $t('Save') }}

				<b-spinner v-if="saving" small />
				<fa v-else class="ml-1" icon="save" />
			</b-button>
		</b-card-footer>
	</b-card>
</template>
<script>
import ELEMENTS_FIELDS_LOOKUP from '@/constants/elements_fields_lookup';

import {cloneDeep, isEqual} from 'lodash'
import Form from 'vform';
import DuplicateModal from "@/components/DuplicateModal";
import TreeView from "@/components/TreeView";
import SubtractionModeSelect from "@/components/selects/SubtractionModeSelect";

export default {
	name: 'WallElementsItem',
	components: {SubtractionModeSelect, TreeView, DuplicateModal},
	props: {
		value: {
			type: Object,
			default: () => ({}),
		},
		element: {
			type: Object,
			default: () => ({}),
		},
		apiUrl: {
			type: String,
			required: true
		},
		title: {
			type: String,
			required: true
		},
		elementType: {
			type: String,
			required: true
		},

	},
	data() {
		return {
			saving: false,
			deleting: false,
			form: new Form({
				properties: [],
			}),
			dirtyProperties: []
		};
	},
	computed: {
		fieldsLookup() {
			return ELEMENTS_FIELDS_LOOKUP[this.elementType];
		},

		propertiesCount() {
			return this.form.properties ? this.form.properties.length : 0;
		},

		wallElementId() {
			return this.value ? this.value.id : null;
		},
		isDirty() {
			return !isEqual(this.form.properties, this.value ? this.value.properties : []);
		},
		projectId() {
			return this.element.project_id;
		}
	},
	watch: {
		value: {
			handler(newValue) {
				this.form = newValue ? new Form(cloneDeep(newValue)) : {properties: []};
			},
			immediate: true
		},
		form: {
			handler() {
				this.handleDirtyProperties()
			},
			deep: true
		}
	},
	methods: {
		handleDirtyProperties() {
			// Fixme: Becuase value.properties and form.properties dont have a unique identifier the comparison can be buggy
			this.dirtyProperties = []

			if (this.form.properties.length){
				this.form.properties.forEach((property, index) => {
					if (!isEqual(this.form.properties[index].fields, this.value ? this.value.properties[index].fields : null)) {
						this.dirtyProperties.push(index)
					}
				})
			}
		},
		async handleDelete() {
			if (this.deleting) return;

			this.deleting = true;

			try {
				await this.axios.delete(this.apiUrl)
				this.$emit('deleted');
			} catch (e) {
				if (!e.response) {
					throw e
				}
			} finally {
				this.deleting = false;
			}
		},

		async handleSave() {
			if (this.saving) return;

			this.saving = true;

			try {
				// Fixme Mabye smarter approach, this is island solution just for properties...
				let result = await this.form.put(this.apiUrl)

				this.form.properties = result.data.info.properties


				await this.$emit('input', cloneDeep(this.form));


				this.$root.$emit('saved::element-service');
				this.$root.$emit('saved::wall-element', result.data)


				this.savedToast();
			} catch (e) {
				if (!e.response) {
					throw e
				}
			} finally {
				this.saving = false;

			}
		},

		handlePropertyDelete(index) {
			this.form.properties.splice(index, 1)
		},
		handleCountChange(newCount) {
			if (!this.form.properties) {
				this.form.properties = [];
			}

			if (newCount > this.propertiesCount) {
				let newRow = {
					fields: [],
					noSubtraction: false,
					// subtraction_mode: SUBTRACTION_MODES.AUTO
					subtraction_mode: this.element.subtraction_mode
				}
				for (let field of this.fieldsLookup) {
					newRow.fields.push({
						name: field.name,
						value: this.element[field.name],
						subtract: false
					})
				}
				this.form.properties.push(newRow);
			} else {
				this.form.properties.pop();
			}
		},

		handleCompleted(data, index) {
			this.form.services[index].info = this.form.services[index].info || {};
			this.form.services[index].info.completed_steps = this.form.services[index].info.completed_steps || [];
			this.form.services[index].info.completed_steps.push(data);
		}
	}
};
</script>
<style scoped>
.close-button {
	position: absolute !important;
	top: 5px;
	right: -20px;
	z-index: 10;
}
</style>